"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_TICK = exports.ANY_PRICE_TICK = exports.TICK_DELTA_MAX = exports.MAX_SAFE_INTEGER = exports.POWERS_OF_2 = exports.MAX_INT_24 = exports.MAX_UINT_160 = exports.MAX_UINT_8 = exports.MAX_UINT_16 = exports.MAX_UINT_24 = exports.MAX_UINT_32 = exports.MAX_UINT_64 = exports.MAX_UINT_128 = exports.MAX_UINT_256 = exports.ADDRESS_ZERO = exports.WAD = exports.Q192 = exports.Q96 = exports.Q32 = exports.Q24 = exports.TWO = exports.ONE = exports.ZERO = exports.NEGATIVE_ONE = void 0;
const ethers_1 = require("ethers");
exports.NEGATIVE_ONE = ethers_1.BigNumber.from(-1);
exports.ZERO = ethers_1.BigNumber.from(0);
exports.ONE = ethers_1.BigNumber.from(1);
exports.TWO = ethers_1.BigNumber.from(2);
exports.Q24 = exports.TWO.pow(24);
exports.Q32 = exports.TWO.pow(32);
exports.Q96 = exports.TWO.pow(96);
exports.Q192 = exports.TWO.pow(192);
exports.WAD = ethers_1.BigNumber.from(10).pow(18);
exports.ADDRESS_ZERO = '0x0000000000000000000000000000000000000000';
exports.MAX_UINT_256 = ethers_1.BigNumber.from('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff');
exports.MAX_UINT_128 = exports.TWO.pow(128).sub(exports.ONE);
exports.MAX_UINT_64 = exports.TWO.pow(64).sub(exports.ONE);
exports.MAX_UINT_32 = exports.TWO.pow(32).sub(exports.ONE);
exports.MAX_UINT_24 = exports.TWO.pow(24).sub(exports.ONE);
exports.MAX_UINT_16 = exports.TWO.pow(16).sub(exports.ONE);
exports.MAX_UINT_8 = exports.TWO.pow(8).sub(exports.ONE);
exports.MAX_UINT_160 = exports.TWO.pow(160).sub(exports.ONE);
exports.MAX_INT_24 = exports.TWO.pow(23).sub(exports.ONE);
exports.POWERS_OF_2 = [128, 64, 32, 16, 8, 4, 2, 1].map((pow) => [pow, exports.TWO.pow(pow)]);
exports.MAX_SAFE_INTEGER = ethers_1.BigNumber.from(String(Number.MAX_SAFE_INTEGER));
exports.TICK_DELTA_MAX = 16096;
exports.ANY_PRICE_TICK = ethers_1.BigNumber.from(140737496743935);
exports.EMPTY_TICK = exports.TWO.pow(23).sub(exports.ONE);
